import script from "./TextSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextSearch.vue?vue&type=script&setup=true&lang=ts"

import "./TextSearch.vue?vue&type=style&index=0&id=256f846a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256f846a"]])

export default __exports__